<template>
  <div>
    <PrivacyCom class="m-doc container"></PrivacyCom>
  </div>
</template>
<script>
import PrivacyCom from '../components/privacyCom.vue'
export default {
  components: {
    PrivacyCom,
  },
}
</script>
<style lang='scss'>
@import '@/styles/public';
.m-doc{
    padding: 120px 60px 80px;
    // padding-bottom: 80px;
    &.container{
        width: 100%;
    }
    .title{
        text-align: center;
        font-size: 72px;
        font-weight: bold;
        color: $theme-color;
        margin: 80px 0 60px;
    }
  .title-f{
    text-align: center;
    font-size: 46px;
    font-weight: normal;
  }
  .sub-title {
    /* color: $theme-color; */
    font-size: 40px;
    margin: 30px 0 10px;
    font-weight: bold;
    display: block;
  }
  .privacy-space {
    display: block;
    padding-left: 10px;
    margin-bottom: 10px;
  }
    .text{
        font-size: 40px;
        color: #565D75;
    }
    .s-title{
        color: $theme-color;
        font-size: 46px;
        margin: 70px 0 30px;
    }
}
</style>
